/**
 * Terminal typing effect
 * Simulates text being typed in a terminal/command-line interface
 */

export function startTerminalTypingEffect(containerEl) {
  if (!containerEl) return () => {};

  const timeouts = [];
  const intervals = [];
  let retryTimeoutId = null;

  const run = () => {
    const typingElements = containerEl.querySelectorAll('[data-terminal-type]');
    if (!typingElements || typingElements.length === 0) return false;

    typingElements.forEach((el, index) => {
      const fullText = el.getAttribute('data-terminal-type') || el.textContent;
      const speed = parseInt(el.getAttribute('data-type-speed') || '50', 10);
      const delay = parseInt(el.getAttribute('data-type-delay') || '0', 10) + index * 200;

      el.textContent = '';
      el.style.opacity = '1';

      const timeoutId = setTimeout(() => {
        let charIndex = 0;

        const intervalId = setInterval(() => {
          if (charIndex < fullText.length) {
            el.textContent = fullText.substring(0, charIndex + 1);
            charIndex++;
          } else {
            clearInterval(intervalId);
          }
        }, speed);

        intervals.push(intervalId);
      }, delay);

      timeouts.push(timeoutId);
    });

    return true;
  };

  const started = run();
  if (!started) {
    retryTimeoutId = setTimeout(() => {
      run();
    }, 60);
  }

  // Cleanup function
  return () => {
    timeouts.forEach((id) => clearTimeout(id));
    intervals.forEach((id) => clearInterval(id));
    if (retryTimeoutId) clearTimeout(retryTimeoutId);
  };
}

/**
 * Typewriter effect for single element
 */
export function typewriterEffect(element, text, options = {}) {
  if (!element) return () => {};

  const {
    speed = 50,
    delay = 0,
    cursor = true,
    onComplete = null
  } = options;

  let timeoutId = null;
  let intervalId = null;
  let cursorIntervalId = null;

  element.textContent = '';
  
  // Add cursor if requested
  if (cursor) {
    const cursorSpan = document.createElement('span');
    cursorSpan.className = 'typing-cursor';
    cursorSpan.textContent = '█';
    cursorSpan.style.animation = 'cursor-blink 1s step-end infinite';
    element.appendChild(cursorSpan);
  }

  timeoutId = setTimeout(() => {
    let charIndex = 0;
    const textNode = document.createTextNode('');
    
    if (cursor) {
      element.insertBefore(textNode, element.firstChild);
    } else {
      element.appendChild(textNode);
    }
    
    intervalId = setInterval(() => {
      if (charIndex < text.length) {
        textNode.textContent = text.substring(0, charIndex + 1);
        charIndex++;
      } else {
        clearInterval(intervalId);
        
        // Remove cursor after completion
        if (cursor) {
          const cursorEl = element.querySelector('.typing-cursor');
          if (cursorEl) {
            setTimeout(() => {
              cursorEl.style.opacity = '0';
            }, 500);
          }
        }
        
        if (onComplete) onComplete();
      }
    }, speed);
  }, delay);

  // Cleanup function
  return () => {
    if (timeoutId) clearTimeout(timeoutId);
    if (intervalId) clearInterval(intervalId);
    if (cursorIntervalId) clearInterval(cursorIntervalId);
  };
}
